/* eslint-disable */
import {
  Box, Button,
  createStyles, Grid,
  Input,
  Theme, Tooltip,
  withStyles,
} from "@material-ui/core";
import { withTranslation } from "react-i18next";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import React, {Component} from "react";
import { connect } from "react-redux";
import { startFAQSync } from "../../../utils/store/actions/users.actions";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: "20px",
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.secondary,
    },
  });

class FAQSyncConfiguration extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      clientName: "",
    };
  }

  render() {
    const { classes, t } = this.props;
    return (
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="faqTemplatesContainer"
        >
          <Typography className={classes.heading}>
            {t("FAQ")}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid>
            <Box marginBottom="20px" style={{ textDecoration: "underline" }}>
              <a href="https://b4finance-kyc34.atlassian.net/wiki/spaces/B4FIN/pages/3288203268/Introduction+l+utilisation+d+Outline" target="_blank">
                Documentation
              </a>
            </Box>
            <Tooltip className={classes.Tooltip} title="Synchronize FAQ from Outline documents" placement="top">
              <div style={{ maxWidth: "fit-content" }}>FAQ synchronization:</div>
            </Tooltip>
            <Box
              style={{
                display: "flex",
                gap: "10px"
              }}
            >
              <Input
                placeholder="Client name"
                onChange={(e) => this.setState({...this.state, clientName: e.target.value})}
              />
              <Button
                disabled={!this.state.clientName}
                onClick={() => {
                  if (this.state.clientName) {
                    this.props.startFAQSync(this.state.clientName);
                  }
                }}
              >
                Start
              </Button>
            </Box>
          </Grid>
        </AccordionDetails>
      </Accordion>
    );
  }
}

const mapStateToProps = (state: any) => ({
  ...state,
});

const mapDispatchToProps = {
  startFAQSync
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(FAQSyncConfiguration)));
